export const setExperimentInStorage = (experiment) => {
    if(experiment === null) {
        window.localStorage.removeItem("experiment")
    }
    else {
        let exp = JSON.stringify(experiment);
        window.localStorage.setItem("experiment", exp);
    }
}

export const getExperimentFromStorage = () => {
    let exp = window.localStorage.getItem("experiment");
    if(exp == null || exp === "")
        return null;
    return JSON.parse(exp);
}